import { NgModule } from '@angular/core';
import { CommonLibModule } from '../common-lib/common-lib.module';
import { ChangeLangService } from './change-lang.service';

@NgModule({
  providers: [ChangeLangService],
  imports: [CommonLibModule],
})
export class ChangeLangServiceModule {}
